export type BannerAdType =
    | 'standard'
    | 'large'
    | 'full'
    | 'mediumRectangle'
    | 'leaderboard'
    | 'dynamic'
    | 'dynamicLeaderboard';
